import { Link as GatsbyLink, GatsbyLinkProps } from 'gatsby';
import React from 'react';

type LinkProps = Omit<GatsbyLinkProps<any>, 'ref'>;

function Link(
  { to, activeClassName, partiallyActive, children, ...otherProps }: LinkProps,
  forwardedRef: React.Ref<HTMLAnchorElement>,
) {
  const isExternal = /^(https?:|mailto:|tel:)/.test(to);

  if (isExternal) {
    return (
      <a ref={forwardedRef} href={to} target='_blank' rel='noopener noreferrer' {...otherProps}>
        {children}
      </a>
    );
  }

  return (
    <GatsbyLink
      ref={forwardedRef as any}
      to={to}
      activeClassName={activeClassName}
      partiallyActive={partiallyActive}
      {...otherProps}
    >
      {children}
    </GatsbyLink>
  );
}
export default React.forwardRef(Link);
